import cssVars from "css-vars-ponyfill";
<template>
  <login-layout v-if="client_config.client_id" :style="brandColours">
    <form class="t-login__form">
      <div class="t-login__field">
        <label for="email" class="control-label">Email:</label>
        <input
          class="form-control"
          id="email"
          type="email"
          name="email"
          v-model="$v.email.$model"
          autofocus />
        <vuelidate-help label="Email" :field="$v.email"/>
      </div>

      <div class="t-login__field">
        <label for="password" class="control-label">Password:</label>
        <input
          id="password"
          type="password"
          class="form-control"
          name="password"
          v-model="$v.password.$model"/>
        <vuelidate-help label="Password" :field="$v.password"/>
      </div>

      <div class="flex items-center">
        <ladda-button
          ref="search"
          class="btn btn-dark"
          type="submit"
          :click="handleLoginCallback">
          Login
        </ladda-button>
       <router-link to="/reset-password"
         tag="button"
         ref="back"
         class="reset-link"
         type="button">
          Forgot your password?
        </router-link>
      </div>
    </form>
  </login-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import cssVars from 'css-vars-ponyfill'
import { notify } from 'utils'
import LoginLayout from './auth/LoginLayout'
import VuelidateHelp from './misc/VuelidateHelp'
import { email, required } from 'vuelidate/lib/validators'
import { CommonTracker } from 'mixins/analytics'

const tinycolor = require('tinycolor2')

export default {
  data () {
    return {
      email: '',
      password: '',
      remember: true
    }
  },
  mixins: [CommonTracker],
  validations: {
    email: {
      email,
      required
    },
    password: {
      required
    }
  },

  components: {
    LoginLayout,
    VuelidateHelp
  },

  created () {
    this.getClientConfig().then(response => {
      window.document.title = response.data.tenant_details.application_name
      cssVars({
        variables: this.brandColours
      })
    })
  },

  computed: {
    ...mapState('clientConfig', ['client_config']),

    brandColours () {
      return {
        '--brand-primary': this.client_config.colours.brand_primary,
        '--brand-primary-light': tinycolor ? tinycolor(this.client_config.colours.brand_primary).lighten(10).toString() : null,
        '--brand-primary-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_primary).lighten(25).toString() : null,
        '--brand-primary-dark': tinycolor ? tinycolor(this.client_config.colours.brand_primary).darken(10).toString() : null,
        '--brand-primary-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_primary).darken(25).toString() : null,
        '--brand-secondary': this.client_config.colours.brand_info,
        '--brand-secondary-light': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(10).toString() : null,
        '--brand-secondary-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(25).toString() : null,
        '--brand-secondary-dark': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(10).toString() : null,
        '--brand-secondary-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(25).toString() : null,
        '--brand-info': this.client_config.colours.brand_info,
        '--brand-info-light': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(10).toString() : null,
        '--brand-info-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(25).toString() : null,
        '--brand-info-dark': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(10).toString() : null,
        '--brand-info-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(25).toString() : null,
        '--brand-vlast': this.client_config.colours.brand_vlast,
        '--brand-vlast-light': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).lighten(10).toString() : null,
        '--brand-vlast-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).lighten(25).toString() : null,
        '--brand-vlast-dark': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).darken(10).toString() : null,
        '--brand-vlast-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).darken(25).toString() : null,
        '--brand-vlast-text': this.client_config.colours.brand_vlast_text,
        '--brand-vlast-text-light': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).lighten(10).toString() : null,
        '--brand-vlast-text-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).lighten(25).toString() : null,
        '--brand-vlast-text-dark': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).darken(10).toString() : null,
        '--brand-vlast-text-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).darken(25).toString() : null,
        '--brand-text': this.client_config.colours.brand_text,
        '--brand-text-light': tinycolor ? tinycolor(this.client_config.colours.brand_text).lighten(10).toString() : null,
        '--brand-text-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_text).lighten(25).toString() : null,
        '--brand-text-dark': tinycolor ? tinycolor(this.client_config.colours.brand_text).darken(10).toString() : null,
        '--brand-text-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_text).darken(25).toString() : null,
        '--brand-success': '#5cb85c',
        '--brand-success-light': tinycolor ? tinycolor('#5cb85c').lighten(10).toString() : null,
        '--brand-success-lightest': tinycolor ? tinycolor('#5cb85c').lighten(25).toString() : null,
        '--brand-success-dark': tinycolor ? tinycolor('#5cb85c').darken(10).toString() : null,
        '--brand-success-darkest': tinycolor ? tinycolor('#5cb85c').darken(25).toString() : null,
        '--brand-danger': '#d9534f',
        '--brand-danger-light': tinycolor ? tinycolor('#d9534f').lighten(10).toString() : null,
        '--brand-danger-lightest': tinycolor ? tinycolor('#d9534f').lighten(25).toString() : null,
        '--brand-danger-dark': tinycolor ? tinycolor('#d9534f').darken(10).toString() : null,
        '--brand-danger-darkest': tinycolor ? tinycolor('#d9534f').darken(25).toString() : null,
        '--brand-warning': '#f0ad4e',
        '--brand-warning-light': tinycolor ? tinycolor('#f0ad4e').lighten(10).toString() : null,
        '--brand-warning-lightest': tinycolor ? tinycolor('#f0ad4e').lighten(25).toString() : null,
        '--brand-warning-dark': tinycolor ? tinycolor('#f0ad4e').darken(10).toString() : null,
        '--brand-warning-darkest': tinycolor ? tinycolor('#f0ad4e').darken(25).toString() : null,
        '--brand-default': '#ccc',
        '--brand-default-light': tinycolor ? tinycolor('#ccc').lighten(10).toString() : null,
        '--brand-default-lightest': tinycolor ? tinycolor('#ccc').lighten(25).toString() : null,
        '--brand-default-dark': tinycolor ? tinycolor('#ccc').darken(10).toString() : null,
        '--brand-default-darkest': tinycolor ? tinycolor('#ccc').darken(25).toString() : null
      }
    }
  },

  methods: {
    ...mapActions('authentication', ['login']),
    ...mapActions('clientConfig', ['getClientConfig']),

    handleLoginCallback () {
      this.trackEvent(this.analytics.V2.LoginStartEvent)
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.resolve()
      }
      const payload = {
        username: this.email,
        password: this.password,
        remember_me: this.remember,
        grant_type: 'password',
        client_id: this.client_config.client_id,
        client_secret: this.client_config.client_secret
      }

      return this.login(payload)
        .then((response) => {
          if (this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect })
          } else {
            this.trackEvent(this.analytics.V2.LoginCompleteEvent)
            this.$router.push({ name: 'dashboard', query: { src: 'login' } })
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            // handleServerErrors(error, this.errors)
          } else {
            // throw error
            console.error(error)
          }
        })
    }
  }
}
</script>
